import type { CityConfig } from "../city-template/types";

export const fallsChurchVaConfig: CityConfig = {
  city: "Falls Church",
  state: "Virginia",
  stateAbbr: "VA",
  slug: "falls-church-va",
  route: "/cities/falls-church-va",
  title: "Emergency Passport Falls Church VA | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Falls Church, VA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Falls Church, Seven Corners, and the Northern Virginia inner ring. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Falls Church, VA",
  heroSubtitle: "Passport expired before your trip? Traveling from Seven Corners, Bailey's Crossroads, or the Northern Virginia inner ring? We help Falls Church travelers get expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Falls%20Church%20Virginia%20historic%20downtown%20with%20the%20State%20Theatre%20and%20the%20Little%20City%20landmark%2C%20charming%20brick%20buildings%20along%20Broad%20Street%2C%20modern%20transit%20corridor%20with%20Metro%20access%2C%20warm%20afternoon%20light%20with%20tree-lined%20streets%20and%20suburban%20Northern%20Virginia%20charm%2C%20professional%20photography%20showcasing%20this%20independent%20city%20near%20Washington%20DC%20with%20historic%20architecture%20and%20walkable%20downtown%2C%20no%20people%20visible%2C%20scenic%20urban%20landscape%20with%20manicured%20gardens%20and%20historic%20church%20steeple&width=1800&height=700&seq=falls-church-va-hero-001&orientation=landscape",
  heroImageAlt: "Falls Church Virginia historic downtown with State Theatre and charming Broad Street architecture",
  geoPosition: "38.8823;-77.1711",
  geoPlacename: "Falls Church, Virginia",
  regionalAgency: {
    name: "Washington Passport Agency",
    address: "600 19th Street NW, Washington, DC 20006",
    distance: "Located in downtown Washington, DC — approximately 10 miles east of Falls Church via I-66 or the Metro Orange Line",
  },
  nearbyCitiesZips: [
    { name: "Falls Church", zips: "22041, 22042, 22043, 22044, 22046" },
    { name: "Seven Corners", zips: "22044" },
    { name: "Bailey's Crossroads", zips: "22041" },
    { name: "Merrifield", zips: "22116, 22118, 22119" },
    { name: "Annandale", zips: "22003" },
    { name: "Tysons", zips: "22102, 22182" },
    { name: "McLean", zips: "22101, 22102, 22106" },
    { name: "Vienna", zips: "22180, 22181, 22182, 22183, 22185" },
    { name: "Arlington", zips: "22201, 22202, 22203, 22204, 22205, 22206, 22207, 22209, 22211, 22213, 22214" },
    { name: "Alexandria", zips: "22301, 22302, 22304, 22305, 22311, 22312, 22314" },
    { name: "Fairfax", zips: "22030, 22031, 22032, 22033, 22034, 22035, 22036, 22037, 22038, 22039" },
    { name: "Springfield", zips: "22150, 22151, 22152, 22153, 22156, 22158, 22159, 22160, 22161" },
    { name: "Burke", zips: "22009, 22015, 22032" },
    { name: "Woodbridge", zips: "22191, 22192, 22193, 22194, 22195" },
    { name: "Manassas", zips: "20108, 20109, 20110, 20111, 20112, 20113" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent travel departures from the Falls Church and Northern Virginia inner ring" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "NoVA Inner Ring Hub", desc: "Serving Falls Church, Seven Corners, Bailey's Crossroads, and the immediate DC metro area" },
  ],
  internalLinks: [
    { name: "Virginia state passport services", route: "/states/virginia" },
    { name: "Arlington VA passport services", route: "/cities/arlington-va" },
    { name: "Alexandria VA passport services", route: "/cities/alexandria-va" },
    { name: "McLean VA passport services", route: "/cities/mclean-va" },
    { name: "Fairfax VA passport services", route: "/cities/fairfax-va" },
    { name: "Vienna VA passport services", route: "/cities/vienna-va" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Falls Church remotely via secure courier. We do not have a walk-in office in Falls Church — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Falls Church and Northern Virginia inner ring travelers.",
  fpcOfficeDistance: "Serving all of Falls Church and the Northern Virginia inner ring including Seven Corners, Bailey's Crossroads, Merrifield, Annandale, and the immediate DC metro area",
  serviceAreaIntro: "From the historic downtown of Falls Church to the busy corridors of Seven Corners and Bailey's Crossroads, from the Merrifield Mosaic District to the quiet neighborhoods near Lake Barcroft, from the transit-connected streets along the Metro Orange Line to the suburban communities bordering Arlington and Fairfax — Fast Passport Center serves every corner of Falls Church and the Northern Virginia inner ring. We regularly help travelers from Annandale, Tysons, and McLean get their passports fast.",
  nearbyCitiesIntro: "We serve all Falls Church neighborhoods and the Northern Virginia inner ring including Seven Corners, Bailey's Crossroads, Merrifield, Annandale, and communities bordering Arlington and Fairfax.",
  howItWorksIntro: "Most Falls Church travelers complete everything online and ship documents overnight. No need to drive to the Washington regional agency or wait in long government lines.",
  mistakesIntro: "Falls Church travelers often face the temptation to drive to the Washington regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Falls Church and Northern Virginia inner ring travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Falls Church? Here are the most common ones we hear from Northern Virginia inner ring travelers.",
  statePageRoute: "/states/virginia",
  statePageName: "Virginia",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Falls Church international flights and last-minute travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Jennifer H.",
      location: "Falls Church, VA",
      rating: 5,
      text: "I live near Seven Corners and needed an emergency passport for a business trip to London with 5 days notice. Fast Passport Center had my renewal in 3 days. I shipped from the UPS on Broad Street and it was completely seamless. No need to drive to DC or wait in government lines.",
      service: "Emergency Passport",
    },
    {
      name: "Michael S.",
      location: "Merrifield, VA",
      rating: 5,
      text: "As a Merrifield resident working near the Mosaic District, I was worried about finding expedited passport services close to home. Fast Passport Center made it incredibly easy. Everything was done online, and my renewal was back in 4 days. The convenience for Northern Virginia professionals is unbeatable.",
      service: "Passport Renewal",
    },
    {
      name: "Laura T.",
      location: "Falls Church, VA",
      rating: 5,
      text: "First passports for my two children before a family trip to Italy. Fast Passport Center handled all the parental consent requirements perfectly and had both passports in 5 days. For Falls Church families, this is the best expedited passport service available.",
      service: "Child Passport",
    },
    {
      name: "Robert D.",
      location: "Falls Church, VA",
      rating: 5,
      text: "Lost my passport 2 days before a conference in Tokyo. I was in absolute panic. Fast Passport Center had a replacement in my hands in 36 hours. They saved my career and my international conference. Falls Church professionals need this service.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "falls-church-va-1",
      name: "Falls Church Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "223 W Broad Street",
      city: "Falls Church",
      state: "VA",
      zip: "22046",
      phone: "(703) 534-5304",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM; Sat: 9:00 AM – 12:00 PM",
      distance: "Downtown Falls Church",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Falls Church facility. Full passport services with appointment. Call ahead to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "falls-church-va-2",
      name: "Bailey's Crossroads Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3615 Bailey's Crossroads",
      city: "Falls Church",
      state: "VA",
      zip: "22041",
      phone: "(703) 820-3692",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Bailey's Crossroads, south Falls Church",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves south Falls Church and Bailey's Crossroads area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "falls-church-va-3",
      name: "Annandale Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "6900 Columbia Pike",
      city: "Annandale",
      state: "VA",
      zip: "22003",
      phone: "(703) 941-5314",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM; Sat: 9:00 AM – 12:00 PM",
      distance: "Annandale, east of Falls Church",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Annandale and eastern Falls Church area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "falls-church-va-4",
      name: "Merrifield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2750 Gallows Road",
      city: "Vienna",
      state: "VA",
      zip: "22180",
      phone: "(703) 698-5738",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Merrifield, west of Falls Church",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Merrifield and Mosaic District area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "falls-church-va-5",
      name: "Arlington Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3118 Washington Blvd",
      city: "Arlington",
      state: "VA",
      zip: "22201",
      phone: "(703) 993-5534",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM; Sat: 9:00 AM – 12:00 PM",
      distance: "Arlington, east of Falls Church",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Arlington and eastern Falls Church area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "falls-church-va-6",
      name: "City of Falls Church Clerk",
      type: "City Clerk",
      address: "300 Park Avenue",
      city: "Falls Church",
      state: "VA",
      zip: "22046",
      phone: "(703) 248-5001",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Downtown Falls Church",
      website: "https://www.fallschurchva.gov",
      websiteLabel: "City of Falls Church",
      notes: "Provides vital records and birth certificates. Not a passport acceptance facility but useful for document collection.",
      icon: "ri-building-2-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — Metro or drive to DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Falls Church photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Northern Virginia acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Falls Church applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Washington DC regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Falls Church families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Falls Church travelers often assume standard processing will be fine. It takes 8-11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Falls Church or nearby." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Falls Church address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Falls Church before my international trip?", a: "Yes. Fast Passport Center provides emergency passport services in Falls Church for travelers with urgent international departures. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24-48 hour turnaround — perfect for last-minute trips from the Northern Virginia inner ring." },
    { q: "How fast can I renew my passport in Falls Church?", a: "Fast Passport Center offers fast passport renewal in Falls Church in as little as 24-48 hours through our emergency courier service. For less urgent travel, our 3-5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Falls Church?", a: "The nearest regional passport agency to Falls Church is the Washington Passport Agency, located approximately 10 miles east in downtown Washington, DC. Accessible via I-66 or the Metro Orange Line. For urgent processing without the commute, Fast Passport Center's registered courier service achieves 24-48 hour turnaround from Falls Church." },
    { q: "Can I get a same-day passport appointment near Falls Church?", a: "Same-day passport appointments are only available at the Washington Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24-48 hour emergency courier processing is the fastest guaranteed option for Falls Church residents." },
    { q: "Can I expedite a child passport in Falls Church?", a: "Yes. Fast Passport Center expedites child passports in Falls Church for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Falls Church and Northern Virginia families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Falls Church with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24-48 hours." },
    { q: "How fast can I get a passport in Falls Church?", a: "With Fast Passport Center's emergency courier service, Falls Church travelers can receive their passport in as little as 24-48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to drive to the Washington Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities near Falls Church?", a: "Popular options include the Falls Church Post Office (22046), Bailey's Crossroads Post Office (22041), Annandale Post Office (22003), and Merrifield Post Office (22180). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "What if I live in Seven Corners or Bailey's Crossroads?", a: "We serve the entire Falls Church area including Seven Corners, Bailey's Crossroads, Merrifield, and all neighborhoods bordering Arlington and Fairfax. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Falls Church?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24-48 hour processing, 3-5 day expedited, or standard options. Contact us for a personalized quote." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Falls Church", address: "700 W Broad St, Falls Church, VA 22046", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walgreens — Falls Church", address: "3100 Graham Rd, Falls Church, VA 22042", hours: "Mon-Sun: 7AM-11PM" },
    { name: "FedEx Office — Falls Church", address: "3415 Columbia Pike, Arlington, VA 22204", hours: "Mon-Fri: 7AM-9PM, Sat: 8AM-6PM" },
    { name: "CVS Pharmacy — Annandale", address: "7023 Columbia Pike, Annandale, VA 22003", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walgreens — Merrifield", address: "8190 Strawberry Ln, Falls Church, VA 22042", hours: "Mon-Sun: 7AM-11PM" },
    { name: "CVS Pharmacy — Seven Corners", address: "6269 Arlington Blvd, Falls Church, VA 22044", hours: "Mon-Sun: 8AM-10PM" },
  ],
  dmvLocations: [
    {
      name: "Virginia DMV — Falls Church",
      address: "2680 W Broad St, Falls Church, VA 22046",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Virginia DMV — Fairfax",
      address: "10255 Main St, Fairfax, VA 22030",
      hours: "Mon-Fri: 8AM-5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "Virginia DMV — Arlington",
      address: "4150 S Four Mile Run Dr, Arlington, VA 22204",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Serves Arlington and eastern Falls Church area. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "DCA",
      name: "Ronald Reagan Washington National Airport",
      distance: "Approximately 8 miles east of Falls Church",
      address: "2401 Smith Blvd, Arlington, VA 22202",
      note: "The closest major airport to Falls Church. Domestic and international flights. Accessible via Metro Orange Line or I-66.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Airport",
      featured: true,
    },
    {
      code: "IAD",
      name: "Washington Dulles International Airport",
      distance: "Approximately 20 miles west of Falls Church",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "Major international hub for the DC metro area. Accessible via Route 7 or the Silver Line Express.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Airport",
      featured: false,
    },
    {
      code: "BWI",
      name: "Baltimore/Washington International Airport",
      distance: "Approximately 45 miles northeast of Falls Church",
      address: "7050 Friendship Rd, Baltimore, MD 21240",
      note: "Alternative international hub for DC area travelers. Accessible via I-95.",
      flightUrl: "https://www.bwiairport.com/",
      flightLabel: "BWI Airport",
      featured: false,
    },
  ],
};